export default __webpack_public_path__ + "static/media/1.458e8462.svg";